export class SolicitacaoComprasInputDto {
    Descricao: string;
    AnoSafraId: number;
    IsPlanejada: boolean;
    AnoSafraIds: number[] = [];
    CulturaIds: number[] = [];
    FazendaIds: number[] = [];
    PlanejamentoIds : number[] = [];
    Itens: ItensSolicitacaoComprasDTO[] = [];

    constructor() {
        this.Descricao = '';
        this.AnoSafraId = null;
        this.IsPlanejada = false;
        this.AnoSafraIds = [];
        this.CulturaIds = [];
        this.FazendaIds = [];
        this.PlanejamentoIds  = [];
        this.Itens = [];
    }
}

export class ItensSolicitacaoComprasDTO {
  Id!: number;
  SolicitacaoComprasId!: number;
  ProdutoId!: number;
  PrincipioAtivo!: string;
  Dose!: number;
  NumeroAplicacoes!: number;
  PlanejamentoId!: number;
  EstoqueAtual!: number;
  PrecoUnitarioMedio!: number;
  UnidadeMedida!: string;
  GrupoProdutoId!: number;
  ProdutoDescricao!: string;
  DescricaoGrupoProduto!: string;
  AreaTotal!: number;
  QuantidadeTotal!: number;
  QuantoComprar!: number;
  ValorTotal!: number;
  ValorMedioHa!: number;
  DataMinimoEntrega?: Date;
  DataMaximoEntrega?: Date;

  constructor() {
    this.Id = 0;
    this.SolicitacaoComprasId = 0;
    this.ProdutoId = 0;
    this.PrincipioAtivo = '';
    this.Dose = 0;
    this.NumeroAplicacoes = 0;
    this.PlanejamentoId = 0;
    this.EstoqueAtual = 0;
    this.PrecoUnitarioMedio = 0;
    this.UnidadeMedida = '';
    this.GrupoProdutoId = 0;
    this.ProdutoDescricao = '';
    this.DescricaoGrupoProduto = 'Outros';
    this.AreaTotal = 0;
    this.QuantidadeTotal = 0;
    this.QuantoComprar = 0;
    this.ValorTotal = 0;
    this.ValorMedioHa = 0;
  }
}

export class SolicitacaoComprasDTO {
    Id: number;
    Descricao: string;
    Status: number;
    StatusNome?: string;
    AnoSafraId: number;
    Fazendas: string;
    Culturas: string;
    Planejamentos : string;
    FazendasIds?: any;
    CulturasIds?: any;
    PlanejamentoIds ?: any;
    DataCadastro: Date | string;
    DataAlteracao: Date | string;
    UsuarioSincroniaDescricao: string;
    UltimaSincronizacao: Date | string;
    ItensSolicitacaos: ItensSolicitacaoComprasDTO[] = [];
}
